<template>
  <sim-card-diagnose
    :card-id="this.id"
    table-type="sim_card"
  />
</template>

<script>
import SimCardDiagnose from '@/views/sim_card_diagnose'

export default {
  name: 'ShowSimCardDiagnose',
  components: { SimCardDiagnose },
  props: {
    id: {
      type: Number,
      required: true
    }
  }
}
</script>

